angular.
module("dx.webapp.integrations", [
	"dx.webapp.api",
	"dx.webapp.droparea",
	"dx.webapp.saml",

	"dx.ui.components.localize",
]);
